import { NavLink } from "react-router-dom";
import { directMessageUrl } from "@/helpers/directMessageUrl";

// The "Message" link under a want ad's author on BLS tenants. A real link when
// it opens the DM thread (open in new tab, URL on hover); a button when it only
// opens the login modal.
const AuthorMessageLink = ({ action, authorUserId, label, onLogin }) =>
  action === "login" ? (
    <button type="button" className="blue-text btn btn-link p-0 border-0 align-baseline" onClick={onLogin}>
      {label}
    </button>
  ) : (
    <NavLink to={directMessageUrl(authorUserId)} className="blue-text">
      {label}
    </NavLink>
  );

export default AuthorMessageLink;
